import React, {Fragment, useContext} from 'react';
import PropTypes from 'prop-types';
import {Button, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import ModalContext from '../../../../fgs/context/ModalContext';

const RemoveItemsModalContent = (props) => {
  const {
    doDeleteUsers,
    selectedItems,
    singleItemId
  } = props;

  const {
    toggle,
  } = useContext(ModalContext);

  const onAction = () => {
    if (selectedItems) {
      doDeleteUsers(selectedItems.map(item => item.id));
    } else {
      doDeleteUsers([singleItemId]);
    }
    
    toggle();
  };

  const bodyText = () => {
    if (selectedItems) {
      return selectedItems.length + " usuário(s)";
    }

    return "1 usuário";
  };

  return (
    <Fragment>
      <ModalHeader>
        Remover Usuários
      </ModalHeader>
      <ModalBody>
        Tem certeza que deseja REMOVER { bodyText() } ?
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={onAction}>Sim, Remover</Button>{' '}
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
      </ModalFooter>
    </Fragment>
  );
};

RemoveItemsModalContent.propTypes = {
  doDeleteUsers: PropTypes.func.isRequired,
  selectedItems: PropTypes.array,
  singleItemId: PropTypes.number
};

export default RemoveItemsModalContent;
